<template>
  <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
    <v-toolbar dense :color="colorBarraFormulario" dark flat>
      <v-toolbar-title v-bind:style="{ color: colorFondoDialog }">
        <span v-bind:style="{ color: 'white' }">Orden de proveedores para el grupo: {{ this.ordenGrupo.nombre }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-icon size="30" :color="'white'" @click="_cerrarVentana">mdi-close-circle</v-icon>
    </v-toolbar>
    <v-card-text>
    
      <v-card v-for="punto in this.ordenGrupo.puntos" :key="punto.id" class="mb-2 mt-6" color="rgb(250, 250, 250)">
          <v-toolbar :dark="!dark" dense color="rgb(120, 130, 120)" flat>
            <v-chip label class="mr-1" color="rgb(60, 60, 60)">
              <span v-bind:style="{ color: 'white' }">
                {{ punto && punto.proveedores ? punto.proveedores.length : '0' }} Proveedores
              </span>
            </v-chip>
            <v-divider class="mx-2" inset vertical></v-divider>
            <v-toolbar-title :dark="!dark">{{ punto.nombre }}</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-card class="mb-1 elevation-0" v-for="proveedor in punto.proveedores" :key="proveedor.id"
              color="rgb(230, 230, 230)">
              <v-card-text>
                <v-row>
                <span class="ml-1 mt-1 mb-1">
                  {{ proveedor.nombre }} 
                </span>
                <v-spacer></v-spacer>
                <v-chip v-if="(punto.proveedores.length > 0 && proveedor.id == punto.proveedores[0].id)" label
                  class="mr-1 px-1" color="transparent">
                  <v-icon color="transparent">mdi-arrow-up-bold</v-icon>
                </v-chip>
                <v-chip v-if="(proveedor.id != punto.proveedores[0].id)" label class="mr-1 px-1" link color="green lighten-1" @click="_cambiarOrdenGrupo(punto.id, proveedor.id, 'SUBIR')">
                  <v-icon color="white">mdi-arrow-up-bold</v-icon>
                </v-chip>
                <v-chip
                  v-if="(punto.proveedores.length > 0 && proveedor.id == punto.proveedores[punto.proveedores.length - 1].id)"
                  label class="mr-1 px-1" color="transparent">
                  <v-icon color="transparent">mdi-arrow-down-bold</v-icon>
                </v-chip>
                <v-chip v-if="proveedor.id != punto.proveedores[punto.proveedores.length - 1].id" label class="mr-1 px-1" link color="green lighten-1" @click="_cambiarOrdenGrupo(punto.id, proveedor.id, 'BAJAR')">
                  <v-icon color="white">mdi-arrow-down-bold</v-icon>
                </v-chip>
              </v-row>
              </v-card-text>
              <v-divider></v-divider>
            </v-card>
          </v-card-text>
        </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";


export default {
  name: "OrdenGrupoFormulario",

  data: () => ({
    loading: false,
  }),

  props: {
    
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",
      "colorAccent1",
      "colorAccent2",
      "colorAccent3",
      "colorBarraFormulario",
      "colorFondoDialog",
      "provincias",

    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("grupos", ["ordenGrupo"]),
  },


  mounted() {
    console.log("OrdenGrupoFormulario:", this.ordenGrupo);
  },

  methods: {
    ...mapActions("grupos", ["getOrdenGrupo", "cambiarOrdenGrupo"]),

    _cerrarVentana() {
      this.$emit("cerrarFormularioOrdenGrupo");
    },

    async _cambiarOrdenGrupo(punto_id, proveedor_id, accion) {
      var res = await this.cambiarOrdenGrupo([
          this.access_token,
          this.ordenGrupo.id,
          punto_id,
          proveedor_id,
          accion
        ]);
        console.log('res:', res);
        await this.getOrdenGrupo([this.access_token, this.ordenGrupo.id]);
    },

  },
};
</script>

<style scoped>
.l-map {
  height: 100%;
  width: 100%;
}
</style>
